import { schema } from 'normalizr';

export const addOnDefSchema = new schema.Entity('addOnDefs');
